export const TECHNICAL_SOURCE_LABELS = new Set([
        "tavily",
        "infinitum",
        "infinitum search",
        "ddgs",
        "duckduckgo",
        "duckduckgo search",
        "web",
        "search",
]);

const DOMAIN_SOURCE_LABELS = {
        "sicnoticias.pt": "SIC Notícias",
        "expresso.pt": "Expresso",
        "publico.pt": "Público",
        "observador.pt": "Observador",
        "cnnportugal.iol.pt": "CNN Portugal",
        "iol.pt": "IOL",
        "rtp.pt": "RTP",
        "rr.pt": "Renascença",
        "tsf.pt": "TSF",
        "dn.pt": "Diário de Notícias",
        "jn.pt": "Jornal de Notícias",
        "jornaldenegocios.pt": "Jornal de Negócios",
        "negocios.pt": "Jornal de Negócios",
        "eco.sapo.pt": "ECO",
        "sapo.pt": "SAPO",
        "lusa.pt": "Lusa",
        "cmjornal.pt": "Correio da Manhã",
        "visao.pt": "Visão",
        "sabado.pt": "Sábado",
        "dinheirovivo.pt": "Dinheiro Vivo",
        "idealista.pt": "Idealista",
        "gov.pt": "Governo",
        "parlamento.pt": "Assembleia da República",
        "dre.pt": "Diário da República",
        "agenciabrasil.ebc.com.br": "Agência Brasil",
        "ebc.com.br": "EBC",
        "reuters.com": "Reuters",
        "apnews.com": "Associated Press",
        "bbc.com": "BBC",
        "theguardian.com": "The Guardian",
        "nytimes.com": "The New York Times",
};

const GENERIC_TITLE_SUFFIXES = new Set([
        "energia",
        "política",
        "politica",
        "economia",
        "justiça",
        "justica",
        "sociedade",
        "mundo",
        "media",
        "opinião",
        "opiniao",
        "internacional",
        "última hora",
        "ultima hora",
        "notícias",
        "noticias",
]);

const titleCaseDomainPart = (value) =>
        value
                .replace(/[-_]+/g, " ")
                .replace(/\s+/g, " ")
                .trim()
                .replace(/\b\w/g, (char) => char.toUpperCase()) || "Fonte";

const domainFallbackLabel = (hostname) => {
        const cleaned = hostname.replace(/^www\./, "");
        const parts = cleaned.split(".").filter(Boolean);
        if (parts.length <= 2) return titleCaseDomainPart(parts[0] || "Fonte");
        return titleCaseDomainPart(parts.slice(0, -2).join(" "));
};

const sourceOutletFromTitle = (title) => {
        const parts = String(title || "")
                .split(/\s(?:[-–—|])\s/g)
                .map((part) => part.trim())
                .filter(Boolean);
        if (parts.length < 2) return "";

        const candidate = parts[parts.length - 1].replace(/\s+/g, " ").trim();
        const normalized = candidate.toLowerCase();
        if (GENERIC_TITLE_SUFFIXES.has(normalized)) return "";
        if (candidate.length < 3 || candidate.length > 60) return "";
        if (!/[A-Za-zÀ-ÿ]/.test(candidate)) return "";
        if (!candidate.includes(" ") && candidate !== candidate.toUpperCase()) return "";
        return candidate;
};

export const sourceDisplayOutlet = (source) => {
        const outlet = String(source?.outlet || "").trim();
        if (outlet && !TECHNICAL_SOURCE_LABELS.has(outlet.toLowerCase())) {
                return outlet;
        }

        try {
                const hostname = new URL(source?.url || "").hostname.replace(/^www\./, "");
                const mapped = Object.entries(DOMAIN_SOURCE_LABELS).find(([domain]) =>
                        hostname === domain || hostname.endsWith(`.${domain}`)
                );
                if (mapped) return mapped[1];
                const titleLabel = sourceOutletFromTitle(source?.title);
                return titleLabel || domainFallbackLabel(hostname);
        } catch {
                return sourceOutletFromTitle(source?.title) || outlet || "Fonte";
        }
};
